module.exports = __webpack_public_path__ + "img/04.cddf0ca9.jpg";